var messages = {
  emptyText: 'No data ~',
  clickToDrag: 'Click to drag',
  validationTableName: 'Table row',
  validationError: 'You have $count invalid $table_name data.',
  isRequired: ' is required',
  selectAll: 'All'
};
export default messages;